// extracted by mini-css-extract-plugin
module.exports = {"root":"n45WuVWu21ewEMG1PzFs"};